import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import { randomStrings, stringKeys } from '../constData'
import PlayfairTable from './PlayfairTable';
import CustomButton from '../CustomButton';

const PlayfairCipherExercise = () => {
    const [showAnsButton, setShowAnsButton] = useState(false);
    const [showCorrectAns, setShowCorrectAns] = useState(false);
    const [keyTable, setKeyTable] = useState([])

    const generateString = () => {
        var index = Math.floor(Math.random() * (29 - 0 + 1) + 0);
        return randomStrings[index];
    }

    const generateKey = () => {
        var index = Math.floor(Math.random() * (49 - 0 + 1) + 0);
        return stringKeys[index];
    }

    function handleStringGenerate() {
        var string = generateString();
        document.getElementById("plaintext").value = string.replace(/\s/g, "");
        console.log("We Generated a String! : ", string);
    }

    function handleKeyGenerate() {
        var key = generateKey();
        document.getElementById("key").value = key;
        console.log("We Generated a Key! : ", key);
    }


    function generateKeyTable(key, ks, keyT) {
        let i, j, k, flag = 0;

        // a 26 character hashmap
        // to store count of the alphabet
        let dicty = new Array(26).fill(0);
        for (i = 0; i < ks; i++) {
            let r = key[i].charCodeAt(0) - 65;

            if (key[i] !== 'J') {
                dicty[r] = 2;
            }

        }

        dicty['J'.charCodeAt(0) - 65] = 1;
        i = 0;
        j = 0;

        for (k = 0; k < ks; k++) {
            let r = key[k].charCodeAt(0) - 65;
            if (dicty[r] === 2) {
                dicty[r] -= 1;
                keyT[i][j] = key[k];
                j++;
                if (j === 5) {
                    i++;
                    j = 0;
                }
            }
        }

        for (k = 0; k < 26; k++) {
            if (dicty[k] === 0) {
                keyT[i][j] = String.fromCharCode(k + 65);
                j++;
                if (j === 5) {
                    i++;
                    j = 0;
                }
            }
        }
        setKeyTable(keyT)
        return keyT;
    }

    function search(keyT, a, b, arr) {
        let i, j;

        if (a === 'J')
            a = 'I';
        else if (b === 'J')
            b = 'I';

        for (i = 0; i < 5; i++) {

            for (j = 0; j < 5; j++) {

                if (keyT[i][j] === a) {
                    arr[0] = i;
                    arr[1] = j;
                }
                else if (keyT[i][j] === b) {
                    arr[2] = i;
                    arr[3] = j;
                }
            }
        }
        return arr;
    }

    function checkRepeats(str, ps) {
        let i;
        let newStr = "";
        let tempStr = str
        tempStr = tempStr.replace(/J/g, 'I')
        console.log("After replacing I with J : ", tempStr)
        for (i = 0; i < ps; i += 2) {
            if (tempStr[i] === tempStr[i + 1]) {
                let j;
                let k;
                for (j = 0; j <= i; j++) {
                    newStr += str[j]
                }
                newStr += 'X'
                for (k = i + 1; k < ps; k++) {
                    newStr += str[k]
                }
                str = newStr
                tempStr = newStr
            }
        }
        console.log("After removing repeats : ", str)
        return str
    }

    // Function to make the plain text length to be even
    function prepare(str, ptrs) {

        str = checkRepeats(str, ptrs)

        if (str.length % 2 !== 0) {
            str += 'Z';
        }

        console.log("After adding Z :", str)

        return [str, str.length];
    }


    function encrypt(str, keyT, ps) {
        let i;
        let a = new Array(4).fill(0);
        let newstr = new Array(ps);

        for (i = 0; i < ps; i += 2) {
            let brr = search(keyT, str[i], str[i + 1], a);
            let k1 = brr[0];
            let k2 = brr[1];
            let k3 = brr[2];
            let k4 = brr[3];
            if (k1 === k3) {
                newstr[i] = keyT[k1][(k2 + 1) % 5];
                newstr[i + 1] = keyT[k1][(k4 + 1) % 5];
            }
            else if (k2 === k4) {
                newstr[i] = keyT[(k1 + 1) % 5][k2];
                newstr[i + 1] = keyT[(k3 + 1) % 5][k2];
            }
            else {
                newstr[i] = keyT[k1][k4];
                newstr[i + 1] = keyT[k3][k2];
            }
            const newStep = [str[i], str[i + 1], newstr[i], newstr[i + 1]];
        }
        let res = "";

        for (let i = 0; i < newstr.length; i++) { res += newstr[i]; }
        return res;
    }

    async function encryptByPlayfairCipher(str, key) {
        let ps, ks;
        let keyT = new Array(5);

        for (let i = 0; i < 5; i++) {
            keyT[i] = new Array(5);
        }

        str = str.trim();
        key = key.trim();
        str = str.toUpperCase();
        str = str.replace(/J/g, 'I')

        key = key.toUpperCase();
        key = key.replace(/J/g, 'I')
        ps = str.length;
        ks = key.length;
        [str, ps] = prepare(str, ps);

        let kt = generateKeyTable(key, ks, keyT);
        return encrypt(str, kt, ps);
    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();

        // Read the form data
        const form = e.target;
        const formData = new FormData(form);

        // You can pass formData as a fetch body directly:
        // fetch('/some-api', { method: form.method, body: formData });

        // Or you can work with it as a plain object:
        const formJson = Object.fromEntries(formData.entries());
        console.log(formJson);

        setShowCorrectAns(false);

        var res = encryptByPlayfairCipher(formData.get("plaintext").toUpperCase(),formData.get("key")).then((val1) => {
            var val2 = formData.get("answer").toUpperCase();
            console.log(val1)
            console.log(val2)
            document.getElementById("correctAns").innerHTML = val1;

            if (val1 === val2) {
                document.getElementById("result").innerHTML = "Correct Answer!";
                document.getElementById("result").style.color = "green";
                console.log("Correct Answer!");
                setShowAnsButton(false);
                setShowCorrectAns(false);
            } else {
                document.getElementById("result").innerHTML = "Wrong Answer!";
                document.getElementById("result").style.color = "red";
                console.log("Wrong Answer!");
                setShowAnsButton(true);
            }

        })
    }

    function showAns() {
        setShowCorrectAns(true);
    }

    return (
        <>
            {/* <div style={{ display: keyTable.length === 0 ? "none" : "block" }} >
                <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 30px 0" }}>Key Table</p>
                <PlayfairTable selectedPlain={""} selectedCipher={""} keyTable={keyTable} />
                <br />
            </div>
            <br />
            <br /> */}
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" id='plaintext' />
                    <CustomButton onClick={handleStringGenerate} isSmall={true}>Generate</CustomButton>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleStringGenerate} style={{ marginLeft: 20 }}>Generate</Button> */}
                </label>
                <br />
                <br />
                <label>
                    Key (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="key" id='key'/>
                    <CustomButton onClick={handleKeyGenerate} isSmall={true}>Generate</CustomButton>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleKeyGenerate} style={{ marginLeft: 20 }}>Generate</Button> */}
                </label>
                <br />
                <br />

                <label>
                    Your Answer:
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="answer" id='answer' />
                </label>
                <br />
                <br />
                <CustomButton type="submit" isSmall={true} beforeHover={"#54B435"} afterHover={"#379237"}>Check Answer</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' style={{ backgroundColor: "green" }}>Check Answer</Button> */}

            </form>
            <br />
            <p id='result' style={{ fontSize: 20, fontWeight: "bold", display: "inline" }}></p>
            <CustomButton onClick={showAns} display={showAnsButton ? "inline" : "none"} isSmall={true} beforeHover={"#FF204E"} afterHover={"#E72929"}>Show Answer</CustomButton>
            {/* <Button variant="contained" type='button' size='small' style={{ display: showAnsButton ? "inline" : "none", backgroundColor: "red" }} onClick={showAns}> Show Answer </Button> */}
            <p id='correctAns' style={{ fontSize: 18, fontWeight: "bold", display: showCorrectAns ? "block" : "none" }}></p>
        </>
    )
}

export default PlayfairCipherExercise